/**
 * Sticky ATC selection summary — matcha / truck / chasen share one baseline.
 */
(function () {
  function selectedQty() {
    const selected = document.querySelector('.quantity-break--selected');
    if (selected?.dataset?.quantity) return parseInt(selected.dataset.quantity, 10);
    return 2;
  }

  function qtyLabel(qty) {
    return qty === 1 ? '1 Matcha Sensatea' : `${qty} Matchas Sensatea`;
  }

  function updateAll() {
    const qty = selectedQty();
    const showShip = qty >= 2;
    const showChasen = qty >= 3;

    document.querySelectorAll('[data-sensatea-sticky-qty]').forEach((el) => {
      el.textContent = qtyLabel(qty);
    });
    document.querySelectorAll('[data-sensatea-sticky-summary]').forEach((el) => {
      el.dataset.qty = String(qty);
    });
    document.querySelectorAll('[data-sensatea-sticky-ship]').forEach((el) => {
      if (showShip) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    document.querySelectorAll('[data-sensatea-sticky-chasen]').forEach((el) => {
      if (showChasen) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function bind() {
    updateAll();
    document.addEventListener('quantity-breaks:updated', updateAll);
    const observer = new MutationObserver(updateAll);
    document.querySelectorAll('[data-ref="quantity-break-item"]').forEach((el) => {
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
    setTimeout(updateAll, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
